<template>
  <div class="import-modals">
    <confirmation-modal
      :cancel="close"
      :confirm="deleteRow"
      title="Confirme exclusão do membro"
      message="Tem certeza que deseja excluir este membro?"
    />
    <commercial-edit-modal />
  </div>
</template>

<script>
import ConfirmationModal from '_shared/ConfirmationModal.vue';
import CommercialActions from './CommercialActions';
import CommercialEditModal from './modal/CommercialEditModal.vue';

export default {
  name: 'commercial-imports',
  mixins: [CommercialActions],
  components: {
    ConfirmationModal,
    CommercialEditModal,
  },
};
</script>
